import { A } from '@mobily/ts-belt';
import { Box, FormHelperText, List, ListItem } from '@mui/material';
import { useTranslate } from 'react-admin';

import { AllocationRecord } from '@sh4res/bo-common/components/B2bCampaigns/steps/allocations/AllocationsConfirmationStep';

type Props = {
  warningEmployees: (Pick<AllocationRecord, 'firstname' | 'lastname' | 'identifier'> & {
    warning: string;
  })[];
};

export const WarningCampaignEmployeesSection = ({ warningEmployees }: Props) => {
  const translate = useTranslate();

  if (A.isEmpty(warningEmployees)) {
    return null;
  }

  return (
    <Box mt={1} sx={{ overflowY: 'auto', maxHeight: '80px' }}>
      <FormHelperText sx={{ fontSize: 14, color: 'warning.main' }}>
        {translate('resources.bo_common.b2b.campaigns.sections.review.warnings.title')}:
        <List dense disablePadding>
          {warningEmployees.map((employee, index) => (
            <ListItem key={index} sx={{ display: 'list-item', pl: 2 }}>
              {`${employee.identifier} - ${employee.firstname} ${employee.lastname} : ${translate(`resources.bo_common.b2b.campaigns.sections.review.warnings.${employee.warning}`)}`}
            </ListItem>
          ))}
        </List>
      </FormHelperText>
    </Box>
  );
};
